<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">All Currencies</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="topFilter">
      <div class="container lg">
        <div class="form-group">
          <label for="filter" class="sr-only">Filter</label>
          <input
            type="text"
            class="form-control filter"
            v-model="filter"
            placeholder="Search..."
          />
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn" v-if="ready">
      <div v-if="history_rows.length != 0">
        <datatable
          :columns="history_columns"
          :data="history_rows"
          :filter-by="filter"
          class=""
        >
          <template slot-scope="{ row }">
            <tr class="pointer" v-on:click="expand(row._id, row)">
              <td colspan="2">
                <span class="font-bold">{{ row.name }}</span>
              </td>
              <td colspan="3">
                <span class="font-bold">{{ row.type }}</span>
              </td>
            </tr>
            <tr class="table-expanded" v-if="expanded == row._id">
              <td colspan="5">
                <div class="animated fadeIn faster">
                  <div class="panel-body">
                    <form
                      @submit.prevent="submit(row._id)"
                      class="form-horizontal"
                    >
                      <div class="form-group">
                        <div class="col-xs-12">
                          Status
                          <select class="form-control" v-model="type">
                            <option value="ENABLED">ENABLED</option>
                            <option value="DISABLED">DISABLED</option>
                            <option value="TRANSFER_ONLY">TRANSFER_ONLY</option>
                            <option value="WITHDRAW_ONLY">WITHDRAW_ONLY</option>
                            <option value="DEPOSIT_ONLY">DEPOSIT_ONLY</option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="col-xs-12">
                          withdraw_fee
                          <input
                            id="value"
                            type="text"
                            v-model="withdraw_fee"
                            class="form-control"
                            placeholder="new value"
                          />
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="col-xs-12">
                          chain
                          <input
                            id="value"
                            type="text"
                            v-model="chain"
                            class="form-control"
                            placeholder="new value"
                          />
                        </div>
                      </div>

                      <button
                        v-if="loading"
                        class="btn btn-default btn-block"
                        disabled=" "
                      >
                        <i class="fad fa-spinner-third fa-spin m-r-xs"></i
                        >Loading
                      </button>
                      <button
                        v-else
                        class="btn btn-accent btn-block text-accent"
                      >
                        Update
                      </button>
                    </form>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </datatable>
        <div class="pager-footer">
          <datatable-pager
            v-model="page"
            type="abbreviated"
            :per-page="per_page"
            class="text-center"
          ></datatable-pager>
        </div>
      </div>
      <div v-else>
        <div class="container-center lg loader-example text-center">
          <i class="fad fa-search fa-4x"></i>
          <h4>You have no users.</h4>
        </div>
      </div>
    </div>
    <div class="container-center lg loader-example" v-else>
      <div class="loader-bar"></div>
    </div>
  </div>
</template>

<script>
import admin from "@/api/admin";
import nativeToast from "native-toast";

export default {
  data() {
    return {
      type: null,
      withdraw_fee: null,
      chain: null,
      ready: false,
      loading: false,
      filter: "",
      history_columns: [
        {
          label: "",
          field: "coin",
          sortable: false,
        },
        {
          label: "",
          field: "name",
          sortable: false,
        },

        { label: "", field: "createdAt", sortable: false },
      ],
      history_rows: [],
      page: 1,
      per_page: 20,
      expanded: null,
    };
  },
  methods: {
    expand(id, row) {
      this.type = row.type;
      this.withdraw_fee = row.withdraw_fee;
      this.chain = row.chain;
      if (this.expanded == id) {
        this.expanded = null;
        return;
      }
      this.expanded = id;
    },
    async submit(id) {
      this.loading = true;
      await admin
        .updatecurrency({
          _id: id,
          type: this.type,
          withdraw_fee: this.withdraw_fee,
          chain: this.chain,
        })
        .then(() => {
          this.loading = false;
          this.getdata();
          nativeToast({
            message: "Successfully.",
            position: "top",
            timeout: 3000,
            type: "success",
          });
        })
        .catch((error) => {
          this.loading = false;
          this.getdata();
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error",
          });
        });
    },
    getdata() {
      this.history_rows = [];
      admin
        .currency()
        .then((res) => {
          res.data.forEach((e) => {
            this.history_rows.push(e);
          });
          this.ready = true;
        })
        .catch((error) => {
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error",
          });
        });
    },
  },
  created() {
    this.getdata();
  },
};
</script>

<style scoped>
.container-center {
  margin-top: 67px;
  padding: 0 0 150px 0;
}
.loader-example {
  margin-top: 200px;
}
</style>
